import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import Modal from '../../../Modal2/Modal';
import Button from '../../../button/Button';
import { TextInput } from '../../../forms';

import { messageGroupsService } from '../../../../newServices/corporateChat';
import { getApiErrorMessage } from '../../../../utils/internalChatGroups';

import internalChatToast from '../../utils/internalChatToast';
import useApplyGroupUpdate from '../../utils/useApplyGroupUpdate';

const RenameGroupModal = ({ show, group, onClose }) => {
    const intl = useIntl();
    const applyGroupUpdate = useApplyGroupUpdate();

    const [name, setName] = useState('');
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (show) setName(group?.name || '');
    }, [show]);

    /** Salvar só faz sentido com um nome, e diferente do atual. */
    const trimmedName = name.trim();
    const canSave = !saving && trimmedName.length > 0 && trimmedName !== (group?.name || '').trim();

    const handleClose = () => {
        if (!saving) onClose();
    }

    /** A janela do grupo continua aberta, já com o nome novo. */
    const handleSave = async () => {
        if (!canSave) return;
        setSaving(true);
        try {
            const res = await messageGroupsService.putMessageGroup(group.id, { name: trimmedName });
            applyGroupUpdate(res && res.data);
            internalChatToast.success(intl.formatMessage({ id: "Grupo renomeado com sucesso!" }));
            setSaving(false);
            onClose();
        } catch (error) {
            internalChatToast.error(
                getApiErrorMessage(error) || intl.formatMessage({ id: "Não foi possível renomear o grupo. Tente novamente." })
            );
            setSaving(false);
        }
    }

    return (
        <Modal
            show={show}
            toggle={handleClose}
            position="center"
            size="sm"
            onPressEnter={handleSave}
        >
            <Modal.Header>{intl.formatMessage({ id: "Renomear grupo" })}</Modal.Header>
            <Modal.Content>
                <div className="p-1">
                    <TextInput
                        id="internal-group-rename"
                        name="groupName"
                        value={name}
                        placeholder={intl.formatMessage({ id: "Nome do grupo" })}
                        onChange={e => setName(e.target.value)}
                    />
                </div>
            </Modal.Content>
            <Modal.Footer>
                <div className="d-flex justify-content-between">
                    <Button.Cancel
                        disabled={saving}
                        onClick={handleClose} />
                    <Button.Save
                        dark
                        disabled={!canSave}
                        loading={saving}
                        onClick={handleSave} />
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default RenameGroupModal;
